/* ──────────────────────────────────────────────────────────────
   ORIGO — theme.js
   AJAX cart, drawer, mobile nav, collection filters, toast.
   No frameworks, vanilla ES6+.
   ────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var R = (window.ORIGO && window.ORIGO.routes) || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_url: '/cart',
    cart_json: '/cart.js',
    checkout_url: '/checkout'
  };

  function $(s, p) { return (p || document).querySelector(s); }
  function $$(s, p) { return Array.from((p || document).querySelectorAll(s)); }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // Shopify AJAX Cart returns prices in the smallest unit (cents).
  // For CLP we want whole units → divide by 100 and format with es-CL.
  function fmtCLP(cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    return '$' + n.toLocaleString('es-CL') + ' CLP';
  }

  // ── Notification toast ───────────────────────────
  var notifTimer = null;
  function notify(msg) {
    var el = $('#notif');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(notifTimer);
    notifTimer = setTimeout(function () { el.classList.remove('show'); }, 2400);
  }

  // ── Cart drawer ──────────────────────────────────
  var overlay = $('#cart-overlay');
  var itemsEl = $('[data-cart-items]');
  var footEl = $('[data-cart-foot]');
  var totalEl = $('[data-cart-total]');

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }
  function showCart() { if (overlay) { overlay.classList.add('open'); overlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function hideCart() { if (overlay) { overlay.classList.remove('open'); overlay.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }

  async function apiFetch(url, opts) {
    var res = await fetch(url, Object.assign({
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
    }, opts || {}));
    // Shopify labels its AJAX cart JSON as text/javascript, so parse the body
    // instead of trusting the content-type header.
    var text = await res.text();
    var body = text;
    var isJson = false;
    try { body = JSON.parse(text); isJson = true; } catch (e) {}
    if (!res.ok) {
      var msg = (body && body.description) || (body && body.message) || ('HTTP ' + res.status);
      var err = new Error(msg);
      err.body = body;
      throw err;
    }
    if (!isJson) {
      // Shopify served us HTML (e.g. password-protected storefront). Treat as a no-op.
      var soft = new Error('Non-JSON response from ' + url);
      soft.softFailure = true;
      throw soft;
    }
    return body;
  }

  async function fetchCart() {
    return apiFetch(R.cart_json, { method: 'GET' });
  }

  async function addItem(variantId, qty) {
    return apiFetch(R.cart_add_url + '.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    });
  }

  async function changeItem(line, quantity) {
    return apiFetch(R.cart_change_url + '.js', {
      method: 'POST',
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function lineImage(item) {
    return item.image || (item.featured_image && item.featured_image.url) || '';
  }

  function renderCart(cart) {
    if (!cart || typeof cart !== 'object' || typeof cart.item_count !== 'number') return;
    setCartCount(cart.item_count);

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-empty">Tu carrito está vacío.<br>¡Elige un té!</p>';
      if (footEl) footEl.hidden = true;
      return;
    }
    if (footEl) footEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var img = lineImage(it);
      var line = i + 1;
      var title = it.product_title || it.title || '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? ' · ' + it.variant_title : '';
      return '<div class="cart-item">' +
        (img
          ? '<img class="cart-thumb" src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '">'
          : '<div class="cart-thumb"></div>') +
        '<div style="flex:1">' +
          '<p class="cart-iname">' + escapeHtml(title) + escapeHtml(variant) + '</p>' +
          '<p class="cart-isub">' + fmtCLP(it.final_price || it.price) + '</p>' +
        '</div>' +
        '<div class="cart-qty">' +
          '<button class="qty-btn" data-qty-change data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
          '<span class="qty-n">' + it.quantity + '</span>' +
          '<button class="qty-btn" data-qty-change data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Agregar uno">+</button>' +
        '</div>' +
      '</div>';
    }).join('');

    if (totalEl) totalEl.textContent = fmtCLP(cart.total_price);

    var waLink = $('#cart-wa');
    if (waLink) {
      var num = (window.ORIGO && window.ORIGO.whatsappNumber) || '';
      if (num) {
        var lines = cart.items.map(function (it) {
          return it.quantity + 'x ' + (it.product_title || it.title) + ' (' + fmtCLP((it.final_price || it.price) * it.quantity) + ')';
        }).join('\n');
        var msg = 'Hola Origo! Quiero pedir:\n' + lines + '\nTotal: ' + fmtCLP(cart.total_price);
        waLink.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
        waLink.style.display = '';
      } else {
        waLink.style.display = 'none';
      }
    }
  }

  // ── Event delegation ─────────────────────────────
  document.addEventListener('click', async function (e) {
    var t = e.target;

    // Cart open
    if (t.closest('[data-cart-toggle]')) {
      e.preventDefault();
      try {
        var c = await fetchCart();
        renderCart(c);
      } catch (err) { /* ignore */ }
      showCart();
      return;
    }

    // Cart close (button or overlay click)
    if (t.closest('[data-cart-close]') || t === overlay) {
      hideCart();
      return;
    }

    // Mobile nav
    if (t.closest('[data-mobile-nav-toggle]')) {
      var m = $('#mobile-menu');
      if (m) m.classList.toggle('open');
      return;
    }

    // Add to cart
    var addBtn = t.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-variant-id');
      var qtyInput = addBtn.closest('form') ? addBtn.closest('form').querySelector('[name="quantity"]') : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variantId) { notify('Producto no disponible'); return; }
      addBtn.disabled = true;
      try {
        await addItem(variantId, qty);
        var cart = await fetchCart();
        renderCart(cart);
        notify('✓ Agregado al carrito');
        showCart();
      } catch (err) {
        notify(err.message || 'No se pudo agregar');
      } finally {
        addBtn.disabled = false;
      }
      return;
    }

    // Quantity change in drawer
    var qtyBtn = t.closest('[data-qty-change]');
    if (qtyBtn) {
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var newQty = Math.max(0, parseInt(qtyBtn.getAttribute('data-qty'), 10));
      try {
        var c = await changeItem(line, newQty);
        renderCart(c);
      } catch (err) { notify(err.message || 'Error al actualizar'); }
      return;
    }

    // Checkout
    if (t.closest('[data-cart-checkout]')) {
      e.preventDefault();
      window.location.href = R.checkout_url;
      return;
    }

    // Collection filters
    var filt = t.closest('.filt[data-filter]');
    if (filt) {
      e.preventDefault();
      var tag = filt.getAttribute('data-filter').toLowerCase();
      $$('.filt[data-filter]').forEach(function (b) { b.classList.toggle('active', b === filt); });
      $$('[data-product-tags]').forEach(function (card) {
        var tags = (card.getAttribute('data-product-tags') || '').toLowerCase();
        var match = (tag === 'all' || tags.indexOf(tag) >= 0);
        card.style.display = match ? '' : 'none';
      });
      return;
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      hideCart();
      var m = $('#mobile-menu');
      if (m) m.classList.remove('open');
    }
  });

  // ── Contact form: enhance with inline success ─────
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-contact-form]');
    if (!f) return;
    // Leave native POST to Shopify /contact handler.
  });

  // ── Initial cart hydrate ──────────────────────────
  fetchCart().then(renderCart).catch(function () { /* noop */ });
})();
